import React, { useEffect, useRef, useState } from 'react'
import styles from './CollapseWrapper.module.scss'
import { ReactComponent as ArrowIcon } from 'components/UI/icons/chevron-down.svg'

const CollapseWrapper = ({
  title,
  children,
  isClosed,
  onClick,
  isOpen,
  isCollapsable,
}) => {
  const contentRef = useRef()

  const [height, setHeight] = useState()

  useEffect(() => {
    const childHeight = contentRef?.current?.children[0].clientHeight
    const padding = 20
    setHeight(childHeight + padding)
  }, [isOpen])

  return (
    <li style={{ '--height': `${height}px` }} className={styles.box}>
      <div
        onClick={onClick}
        className={`${styles.title} ${isOpen ? styles.titleOpen : ''}`}
      >
        {title}
        {!isClosed && isCollapsable === undefined && (
          <div className={`${styles.icon} ${isOpen ? styles.open : ''}`}>
            <ArrowIcon />
          </div>
        )}
      </div>
      {isCollapsable === undefined && (
        <div
          className={
            isOpen ? `${styles.content} ${styles.open}` : `${styles.content}`
          }
          ref={contentRef}
        >
          {children}
        </div>
      )}
    </li>
  )
}

export default CollapseWrapper
